import moment from "moment";
import { WorkOrder } from "../types";

type WorkOrderCreatedAtGroup = 'today' | 'thisWeek' | 'older';

const GROUP_ORDER: WorkOrderCreatedAtGroup[] = ['today', 'thisWeek', 'older'];

const getWorkOrderCreatedAtGroup = (createdAt: string): WorkOrderCreatedAtGroup => {
    const created = moment(createdAt);
    if (!created.isValid()) {
        return 'older';
    }
    const now = moment();
    if (created.isSame(now, 'day')) {
        return 'today';
    }
    if (created.isSameOrAfter(now.clone().startOf('week'), 'day')) {
        return 'thisWeek';
    }
    return 'older';
};

export const groupWorkOrdersByCreatedAt = (
    list: WorkOrder[],
): { group: WorkOrderCreatedAtGroup; items: WorkOrder[] }[] => {
    const buckets: Record<WorkOrderCreatedAtGroup, WorkOrder[]> = {
        today: [],
        thisWeek: [],
        older: [],
    };
    list.forEach(item => {
        buckets[getWorkOrderCreatedAtGroup(item.createdAt)].push(item);
    });
    return GROUP_ORDER
        .filter(group => buckets[group].length > 0)
        .map(group => ({ group, items: buckets[group] }));
};